import { render, staticRenderFns } from "./InventarioPorPosicionesComponent.vue?vue&type=template&id=f78b81e0&"
import script from "./InventarioPorPosicionesComponent.vue?vue&type=script&lang=js&"
export * from "./InventarioPorPosicionesComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports